import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { deleteFilterType } from "./service";
import { FilterTypeDetail } from "./types";

const FilterTypeDeleteDialog = ({
  selectedFilterType,
  open,
  onClose,
}: {
  selectedFilterType: FilterTypeDetail;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          `Are you sure you want to delete the filter type "${selectedFilterType.label}"? This will also delete its options and cannot be undone.`,
          {
            title: "Confirm Filter Type Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteFilterType(selectedFilterType.id);
            showNotification({
              message: "Filter type deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete filter type. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [open, confirm, selectedFilterType, showNotification, onClose]);

  return null;
};

export default FilterTypeDeleteDialog;
